export default function TourismDetails() {
    return (
      <div>

<div className="general-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Tourism</h2>
</div>

{/*Start Main Content*/}
<div className="content-fluid">
    
<div className="mb-960-center-container mid-side-outlines">


        {/*Accordian Start*/}
        <div className="container accordion-container">
            <div className="accordion" id="ParksAccordion">
                {/* Item Start */}
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <br/>
                        <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseParks">
                            <div>
                            <i className="fa-solid fa-dog fa-2xl af-icon"></i>
                            </div>

                            <div><b>&nbsp;Borough Parks</b></div>
                        </button>
                    </h2>
                    <div id="collapseParks" className="accordion-collapse collapse" data-bs-parent="TourismAccordion">
                        <div className="accordion-body">
                        <h4>Park Facilities</h4>
                </div>
                <div className="mb-960-center-container">
                    {/*Full Width Element*/}
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <h4>Morrisville Borough Dog Park</h4>
                            <p><a href="https://maps.app.goo.gl/e8qp3UraWq5p76VS6"><i className="fa-solid fa-location-pin"></i>&nbsp;S. Delmorr Ave. &amp; E. Philadelphia Ave., Morrisville, PA.</a></p>
                            <p>
                                The Dog Park has two areas, one for small dogs 35lbs and under and one for large dogs 36lbs and larger.</p>
                            <p>The small dog area is 50 x 70 feet and the large dog area is 150 x 200 feet.</p>
                            <p>Open daily, from dawn to dusk</p>
                        </div>
                    </div>
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <img src="../img/parks/MB-Dog-Park01.jpg" alt="Morrisville Borough Dog Park" width="100%"/>
                        </div>
                        <br/>
                    </div>

                </div>


                <div className="mb-960-center-container">
                    {/*Full Width Element*/}
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <h4>Levee Riverwalk</h4>
                            <p><a href="https://maps.app.goo.gl/7HpuLacHink7xrFm9"><i className="fa-solid fa-location-pin"></i>&nbsp;Along the Delaware River between the Calhoun St. Bridge and the Trenton Makes Bridge</a></p>
                            <p>
                                This footpath is a flat walking area along the Delaware River from the Calhoun Street Bridge to the Trenton Makes Bridge.</p>

                        </div>
                    </div>
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <img src="../img/parks/MB-Levee-Riverwalk01.jpg" alt="Morrisville Borough Riverside Levee Walk" width="100%"/>
                        </div>
                        <br/>
                    </div>
                </div>

                <div className="mb-960-center-container">
                    {/*Full Width Element*/}
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <h4>Manor Park Playground</h4>
                            <p><a href="https://maps.app.goo.gl/kweFzT9cjQzjaJ2p9"><i className="fa-solid fa-location-pin"></i>&nbsp;98 Penn Ave, Morrisville, PA 19067</a></p>
                            <p>
                                Also called the Cleveland Ave Park, located next to the parking lot for the Morrisville Senior Center. Manor Park offers several pieces of playground equipment, benches, a picnic table and plenty of shade!</p>
                        </div>

                    </div>
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <img src="../img/parks/MB-Manor-Park01.jpg" alt="Manor Park" width="100%"/>
                            <br/>
                        </div>
                    </div>
                </div>
                <div className="mb-960-center-container">
                    {/*Full Width Element*/}
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <h4>Patriots Park At Historic Summerseat </h4>
                            <p><a href="https://www.google.com/maps/place/Patriot's+Park/@40.2082305,-74.7792167,830m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89c159229d49f617:0xc48db4481ba93311!8m2!3d40.2082305!4d-74.7792167!16s%2Fg%2F11h3ngrn3n?entry=ttu&g_ep=EgoyMDI2MDMxNS4wIKXMDSoASAFQAw%3D%3D"><i className="fa-solid fa-location-pin"></i>&nbsp;Hillcrest Ave &amp; Legion Ave, Morrisville PA</a></p>
                            <p>
                                This large park is home to the famous Summerseat, headquarters for George Washington during Dec. 8-14, 1776.</p>
                        </div>
                    </div>
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <img src="../img/parks/MB-Summerseat01.jpg" alt="Historic Summerseat" width="100%"/>

                        </div>
                        <br/>
                    </div>
                </div>
                <div className="mb-960-center-container ">
                    {/*Full Width Element*/}
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <h4>Williamson Park</h4>
                            <p><a href="https://maps.app.goo.gl/mHCbGXUtP9m9UyWS8"><i className="fa-solid fa-location-pin"></i>&nbsp;97 N Delmorr Ave, Morrisville, PA 19067</a></p>
                            <p>
                                Located on the Delaware River, this park features an event stage, playground equipment, and several baseball fields. This is the home facility for Morrisville Little League </p>
                        </div>
                    </div>
                    <div className="mb-960-col-50p">
                        <div className="left-right-padding-1em">
                            <img src="../img/parks/MB-Williamson-Park01.webp" alt="Williamson Park" width="100%"/>
                        </div>
                        <br/>
                    </div>
                </div>
                        </div>
                    </div>
                </div>
                {/* Item Finish */}
            </div>
    {/*Accordian End*/}
   </div>
   <div className="mb-960-center-container mid-side-outlines">


  
     {/*Accordian Start*/}
     <div className="container accordion-container">
            <div className="accordion" id="HistoryAccordion">
                <br/>
                {/* Item Start */}
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHistory">
                            <div>
                            <i className="fa-solid fa-scroll fa-2xl" alt="history of morrisville borough scroll icon"></i>
                            </div>

                            <div><b>&nbsp;History Of Morrisville Borough</b></div>
                        </button>
                    </h2>
                    <div id="collapseHistory" className="accordion-collapse collapse" data-bs-parent="HistoryAccordion">
                        <div className="accordion-body">
                        <div className="mb-960-center-container">
                <div className="timeline">
                    <br/>
                    <span className="timeline-label">
                        <span className="label label-primary">1600s</span>
                    </span>
                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1624 to 1627</h4>
                            </div>
                            <div className="timeline-body">
                                <p>Originally settled in 1624 by Swedish &amp; Dutch immagrants. The area that would become Morrisville began as a trading post in the Delaware River established by the newly formed <a href="https://en.wikipedia.org/wiki/Dutch_West_India_Company">Dutch West India Company&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>. The trading post remained in service through 1627, when the company shifted their focus in the New World towards opportunities in Brazil.</p>
                            </div>
                            <div className="timeline-footer">
                                <p className="text-right"></p>
                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1676 to 1679</h4>
                            </div>
                            <div className="timeline-body">
                                <p>English Quakers begin to settle in the area, "by the Falls", and brought with them the name Crewcorne. Person of note that settled in this area during this time is <a href="https://en.wikipedia.org/wiki/William_Biles">William Biles&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                            </div>
                            <div className="timeline-footer">
                                <p className="text-right"><br/><br/></p>
                            </div>
                        </div>
                    </div>


                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1680</h4>
                            </div>
                            <div className="timeline-body">
                                <p>In <a href="https://books.google.com/books?id=skgVAAAAYAAJ&printsec=frontcover&source=gbs_ge_summary_r&cad=0#v=twopage&q&f=false">The History Of Bucks County, Vol. 1 written by William W.H. Davis in 1905&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>, the first court of Bucks County was held in Crewcorne. Called the "Court of Crewcorne". Residents in the area also took part in deliberation of the Burlington Court.</p>
                            </div>
                            <div className="timeline-footer">
                                <p className="text-right"></p>
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1681</h4>
                            </div>
                            <div className="timeline-body">
                                <p><a href="https://en.wikipedia.org/wiki/Charles_II_of_England">King Charles II&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> grants land holdings along the North Atlantic to <a href="https://en.wikipedia.org/wiki/William_Penn">William Penn&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> to settle debts owed to Penn's father, <a href="https://en.wikipedia.org/wiki/William_Penn_(Royal_Navy_officer)">Sir William Penn&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>. Charles names the granted land, "Pennsylvania" in honor of the senior Penn.</p>

                            </div>
                            <div className="timeline-footer">
                                <p className="text-right"></p>
                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-info">
                            <i className="fa fa-star"></i>
                        </div>
                        <div className="timeline-event timeline-event-info">
                            <div className="timeline-heading">
                                <h4>1682 </h4>
                            </div>
                            <div className="timeline-body">
                                <p>On July 15, 1682, <a href="https://en.wikipedia.org/wiki/William_Markham_(governor)">English Army Captain William Markham&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>, cousin of William Penn and serving as acting governer of Pennsylvania until Penn's arrival in October of the same year, met with members of the native <a href="https://en.wikipedia.org/wiki/Lenape">Lenape&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> people to secure the first purchase of land in Pennsylvania. This meeting took place under an oak tree that stood by a massive outcropping of bedrock near the Delaware River that was on land in the tenure of John Wood, who referred to the site as Gray Stones.</p><br/>
                                <p>Sadly, the oak tree did not survive the centuries since the historic meeting, but the stones remain to this day, located at what is now the northwest corner of <a href="https://www.google.com/maps/@40.2180314,-74.7861674,3a,75y,39.13h,82.57t/data=!3m6!1e1!3m4!1sFEZ5OiyQdRg6hBEv743Q5g!2e0!7i16384!8i8192?coh=205409&entry=ttu&g_ep=EgoyMDI0MDkyMi4wIKXMDSoASAFQAw%3D%3D">Crown St. &amp; Highland Ave. in Morrisville, PA.&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/graystone_01.jpg">
                                            <img src="../img/history/graystone_01.jpg" alt="graystones 1"/>
                                        </a>
                                        <div className="polaroid-desc">Graystones 2024</div>
                                    </div>
                                </div>

                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/graystone_02.jpg">
                                            <img src="../img/history/graystone_02.jpg" alt="graystones 2"/>
                                        </a>
                                        <div className="polaroid-desc">Graystones 2024</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <span className="timeline-label">
                        <span className="label label-primary">1700s</span>
                    </span>


                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1718</h4>
                            </div>
                            <div className="timeline-body">
                                <p>The area of Crewcorne is now a growing settlement operating along the Delaware River. On May 31, 1718, as an act of the Pennsylvania Assembly, Colvin's Ferry is formally established. This ferry serves at the only ferry in the area of Trenton for the next 64 years.</p>
                                <p>At the time, Colvin's Ferry is flanked by Howell's ferry, 4 miles above Trenton, and Dunk's Ferry in Bristol, roughly 10 miles below. A marker in Morrisville denotes the location where Colvin's Ferry operated.</p>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/colvins-ferry-marker.jpg">
                                            <img src="../img/history/colvins-ferry-marker.jpg" alt="colin's ferry marker"/>
                                        </a>
                                        <div className="polaroid-desc">Colin's Ferry Marker</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1765</h4>
                            </div>
                            <div className="timeline-body">
                                <p><a href="https://en.wikipedia.org/wiki/Thomas_Barclay_(diplomat)">Thomas Barkley's&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> father-in-law, Adam Hoops, builds Barkley's 2 1/2 story masonry home at what is now the<a href="https://maps.app.goo.gl/RknVDSwU72xU6KCT7"> junction of Hillcrest &amp; Legion Avenues in Morrisville.&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                                <p>This home would later be owned by Declaration of Independence signers <a href="https://en.wikipedia.org/wiki/Robert_Morris_(financier)">Robert Morris&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> &amp; <a href="https://en.wikipedia.org/wiki/George_Clymer">George Clymer&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>, who would name the house,<a href="https://en.wikipedia.org/wiki/Summerseat_(Morrisville,_Pennsylvania)">"Summerseat"&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/robert_morris.jpg">
                                            <img src="../img/history/robert_morris.jpg" alt="Robert Morris"/>
                                        </a>
                                        <div className="polaroid-desc">Robert Morris, by Charles Willson Peale, from life, c. 1782.<br/>Credit: Independence National Historical Park</div>
                                    </div>
                                </div>

                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/george_clymer.jpg">
                                            <img src="../img/history/george_clymer.jpg" alt="George Clymer"/>
                                        </a>
                                        <div className="polaroid-desc">George Clymer, by unidentified artist, after Charles Willson Peale, c 1807-1810.<br/>
                                            Credit: National Portrait Gallery, Smithsonian Institution; gift of W.B. Shubrick Clymer</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-danger">
                            <i className="fa fa-star"></i>
                        </div>
                        <div className="timeline-event timeline-event-danger">
                            <div className="timeline-heading">
                                <h4>1776</h4>
                            </div>
                            <div className="timeline-body">
                                <p>From December 8th to the 14th, during the <a href="https://en.wikipedia.org/wiki/New_York_and_New_Jersey_campaign">New York &amp; New Jersey campaigns of the American Revolution&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>, Summerseat served as headquarters for <a href="https://en.wikipedia.org/wiki/George_Washington">General George Washington.&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                                <p>20 letters were sent by Washington during his stay at Summerseat, putting into motion the events that would take place 14 days after his departure: <a href="https://en.wikipedia.org/wiki/Battle_of_Trenton">The Battle Of Trenton.&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/summerseat_01.jpg">
                                            <img src="../img/history/summerseat_01.jpg" alt="Summerseat"/>
                                        </a>
                                        <div className="polaroid-desc">Summerseat 2024</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br/>
                    <span className="timeline-label">
                        <span className="label label-primary">1800s</span>
                    </span>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-info">
                            <i className="fa fa-star"></i>
                        </div>
                        <div className="timeline-event timeline-event-info">
                            <div className="timeline-heading">
                                <h4>1804</h4>
                            </div>
                            <div className="timeline-body">
                                <p>To honor Founding Father Robert Morris, key financier of the American Revolution and signer of the Declaration of Independence, the settled area that comprised Colvin's Ferry incorporates as the Borough of Morrisville</p>
                            </div>
                            <div className="timeline-footer">
                                <p className="image-area"></p>

                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1804</h4>
                            </div>
                            <div className="timeline-body">
                                <p>The first bridge between Morrisville &amp; Trenton, a 1,008-foot covered wooden bridge at the site of the current "Trenton Makes" bridge begins construction</p>
                            </div>
                            <div className="timeline-footer">
                                <p className="image-area"></p>

                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1806</h4>
                            </div>
                            <div className="timeline-body">
                                <p>The first bridge between Morrisville &amp; Trenton opens to traffic on January 30, 1806</p>
                            </div>
                            <div className="timeline-footer">
                                <p className="image-area"></p>

                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1833</h4>
                            </div>
                            <div className="timeline-body">
                                <p>Bucks County's first section of railway, constructed by the Philadelphia &amp; Trenton Railroad Company, was built between Morrisville and Bristol.</p>
                            </div>
                            <div className="timeline-footer">
                                <p className="image-area"></p>

                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1884</h4>
                            </div>
                            <div className="timeline-body">
                                <p>The second bridge connecting Morrisville and Trenton opens for business on October 24, 1884. Known as the Calhoun Street Bridge, it is still in operation as of 2024</p>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/calhoun_street_bridge.jpg">
                                            <img src="../img/history/calhoun_street_bridge.jpg" alt="Calhoun Street Bridge"/>
                                        </a>
                                        <div className="polaroid-desc">View north towards the Calhoun Street Bridge from the west bank of the Delaware River<br/>By <a href="https://commons.wikimedia.org/wiki/User:Famartin">Famartin - Own work</a><a href="https://creativecommons.org/licenses/by-sa/4.0"> CC BY-SA 4.0,&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1894</h4>
                            </div>
                            <div className="timeline-body">
                                <p>In April of 1894, the Morrisville Town Council began the construction of a system of water supply to provide fire protection and adequate water for the 1,200 inhabitants of the Borough at that time. The project was completed in October 1894, and the first water permit was issued to Charles S. Taylor on Washington Street.</p>
                            </div>
                        </div>
                    </div>

                    <br/>
                    <span className="timeline-label">
                        <span className="label label-primary">1900s</span>
                    </span>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-blank">
                        </div>
                        <div className="timeline-event timeline-event-primary">
                            <div className="timeline-heading">
                                <h4>1928</h4>
                            </div>
                            <div className="timeline-body">
                                <p>After fire destroyed the original bridge connected Morrisville to Trenton, the Lower Trenton Bridge, also known as the "Trenton Makes" bridge, opened for business on November 30, 1928.</p>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/lower_trenton_bridge.jpg">
                                            <img src="../img/history/lower_trenton_bridge.jpg" alt="Calhoun Street Bridge"/>
                                        </a>
                                        <div className="polaroid-desc">Old &amp; New views of the Trenton Makes Bridge<br/>Credit: <a href="https://www.drjtbc.org/bridge-info/trenton-makes-the-world-takes-sign">Trenton Makes The World Takes Sign Lighting website&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-point timeline-point-info">
                            <i className="fa fa-star"></i>
                        </div>
                        <div className="timeline-event timeline-event-info">
                            <div className="timeline-heading">
                                <h4>1929</h4>
                            </div>
                            <div className="timeline-body">
                                <p>To honor and preserve the history of Graystones, the Bucks County Historical Society, along with citizens in the vacinity, commissions a marker near the bedrock stones still at the site</p>
                                <p>The marker reads:</p>
                                <blockquote>
                                    Near this spot stood the white oak tree that marked the starting point of the survey of the first tract of land purchased of the Indians by William Penn July 15, 1682 on land in the tenure of John Wood and by him called Gray Stones over against the falls of the Delaware comprising all the land lying between the river Delaware and Neshaminy Creek south of a line drawn from the river at a point near the mouth of the Knowles creek nine miles north of here to the said Neshaminy Creek this line being the starting point of the Indian Walk of 1737
                                    Erected and dedicated July 4, 1929 by the Bucks County Historical Society and citizens of this vicinity
                                </blockquote>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/graystone_marker.jpg">
                                            <img src="../img/history/graystone_marker.jpg" alt="Graystone Marker 1"/>
                                        </a>
                                        <div className="polaroid-desc">Graystones Marker 2024<br/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline-footer">
                                <div className="polaroid-responsive">
                                    <div className="polaroid-gallery">
                                        <a target="_blank" href="../img/history/gray_stone_marker.jpg">
                                            <img src="../img/history/gray_stone_marker.jpg" alt="Graystone Marker Magnified"/>
                                        </a>
                                        <div className="polaroid-desc">Graystones Marker Direct<br/>
                                            Credit: Keith S Smith of West Chester, Pennsylvania. <a href="https://www.hmdb.org/PhotoFullSize.asp?PhotoID=415041">Historical Marker Datebase upload</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="timeline-label">
                        <br/>
                        <i className="fa fa-star"></i>
                    </span>
                </div>
            </div>
            <div className="mb-960-center-container mobile-pad-1em">

                <h4>References</h4>

            </div>
            <div className="mb-960-center-container padding-left-right">
                {/*Accordian Start*/}
                <div className="container accordion-container">
                    <div className="accordion" id="historyBAW">
                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHistoryBAW">
                                    <div>
                                        <i className="fa-solid fa-book-open fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Books, Articles, &amp; Websites</b></div>
                                </button>
                            </h2>
                            <div id="collapseHistoryBAW" className="accordion-collapse collapse" data-bs-parent="#historyBAW">
                                <div className="accordion-body">

                                    <ul>
                                        <li><a href="https://www.mercermuseum.org/wp-content/uploads/2014/10/A-Timeline-of-Bucks-County-History-1600s-1900s-rev-8-14-13.pdf">A Timeline of Bucks County History 1600s-1900s<br/><i>https://www.mercermuseum.org/wp-content/uploads/2014/10/A-Timeline-of-Bucks-County-History-1600s-1900s-rev-8-14-13.pdf</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                                        <li><a href="https://historicsummerseat.com/">About Historic Summerseat<br/><i>https://historicsummerseat.com/</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://journals.psu.edu/pmhb/article/view/42790/42511">Bristol: The Origins of a Pennsylvania Market Town<br/><i>https://journals.psu.edu/pmhb/article/view/42790/42511</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://www.drjtbc.org/bridges/calhoun-street/#1453754546711-0c02bfe1-fbfb">Calhoun Street Toll-Supported Bridge - History<br/><i>https://www.drjtbc.org/bridges/calhoun-street/#1453754546711-0c02bfe1-fbfb</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://buckscountyintime.wordpress.com/2012/03/26/graystones-the-treaty-for-pennsylvania/">Graystones ~ The Treaty for Pennsylvania (March 2012)<br/><i>https://buckscountyintime.wordpress.com/2012/03/26/graystones-the-treaty-for-pennsylvania/</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://books.google.com/books?id=skgVAAAAYAAJ&printsec=frontcover&source=gbs_ge_summary_r&cad=0#v=twopage&q&f=false">History of Bucks County, Pennsylvania<br/>William W.H. Davis, Warren Smedley Ely, John Woolf Jordan (1905)<br/><i>https://books.google.com/books?id=skgVAAAAYAAJ&printsec=frontcover&source=gbs_ge_summary_r&cad=0#v=twopage&q&f=false</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://goodspeedhistories.com/life-in-west-new-jersey-1680/">Life In West New Jersey, 1680 (Marfy Goodspeed)<br/><i>https://goodspeedhistories.com/life-in-west-new-jersey-1680/</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://www.jstor.org/stable/44373518">PATRICK COLVIN, THE FERRYMAN OF '76, AND FRIEND OF WASHINGTON—TRENTON'S FIRST CATHOLIC (January 1887 by John D. McCormack<br/><i>https://www.jstor.org/stable/44373518</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://explorepahistory.com/hmarker.php?markerId=1-A-207">Summerseat (Robert Morris) Historical Marker
                                                <br/><i>https://explorepahistory.com/hmarker.php?markerId=1-A-207</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://www.dar.org/national-society/historic-sites-and-properties/summerseat">Summerseat (Daughters of the American Revolution)<br/><i>https://www.dar.org/national-society/historic-sites-and-properties/summerseat</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://buckscountyadventures.org/the-rock-of-ages/">The Rock of Ages (April 2018 by carllavo) <br/><i>https://buckscountyadventures.org/the-rock-of-ages/</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                       
                        {/*Item End*/}
                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHistoryWiki">
                                    <div>
                                        <i className="fa-brands fa-wikipedia-w fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Wikipedia Sources</b></div>
                                </button>
                            </h2>
                            <div id="collapseHistoryWiki" className="accordion-collapse collapse" data-bs-parent="#historyWiki">
                                <div className="accordion-body">

                                    <ul>
                                        <li><a href="https://en.wikipedia.org/wiki/Calhoun_Street_Bridge">Calhoun Street Bridge<br/>https://en.wikipedia.org/wiki/Calhoun_Street_Bridge&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                                        <li><a href="https://en.wikipedia.org/wiki/Charles_II_of_England">Charles II of England<br/><i>https://en.wikipedia.org/wiki/Charles_II_of_England</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/Dutch_West_India_Company">Dutch West India Company<br/><i>https://en.wikipedia.org/wiki/Dutch_West_India_Company</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/George_Clymer">George Clymer<br/><i>https://en.wikipedia.org/wiki/George_Clymer</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/George_Washington">George Washington<br/>https://en.wikipedia.org/wiki/George_Washington&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/Lenape">Lenape Native Americans<br/><i>https://en.wikipedia.org/wiki/Lenape</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/New_York_and_New_Jersey_campaign">New York &amp; New Jersey campaigns of the American Revolution<br/>https://en.wikipedia.org/wiki/New_York_and_New_Jersey_campaign&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                                        <li><a href="https://en.wikipedia.org/wiki/Robert_Morris_(financier)">Robert Morris (financier)<br/><i>https://en.wikipedia.org/wiki/Robert_Morris_(financier)https://en.wikipedia.org/wiki/Robert_Morris_(financier)</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                                        <li><a href="https://en.wikipedia.org/wiki/Summerseat_(Morrisville,_Pennsylvania)">Summerseat (Morrisville, Pennsylvania)<br/><i>https://en.wikipedia.org/wiki/Summerseat_(Morrisville,_Pennsylvania)</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/Thomas_Barclay_(diplomat)">Thomas Barclay (diplomat)<br/><i>https://en.wikipedia.org/wiki/Thomas_Barclay_(diplomat)</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/Lower_Trenton_Bridge">Lower Trenton Bridge<br/>https://en.wikipedia.org/wiki/Lower_Trenton_Bridge&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                                        <li><a href="https://en.wikipedia.org/wiki/Battle_of_Trenton">The Battle Of Trenton<br/><i>https://en.wikipedia.org/wiki/Battle_of_Trenton</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/William_Markham_(governor)">William Markham (governor)<br/><i>https://en.wikipedia.org/wiki/William_Markham_(governor)</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/William_Penn#">William Penn<br/><i>https://en.wikipedia.org/wiki/William_Penn#</i></a>
                                        </li>
                                        <li><a href="https://en.wikipedia.org/wiki/William_Biles">William Biles<br/><i>https://en.wikipedia.org/wiki/William_Biles</i>&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                                    </ul>
                                </div>
                                        </div>
                                    </div>
                                    {/* Item Finish */}
                        </div>
                    </div>
                    {/*Accordian End*/}
                    <br/>
                    <br/><br/><br/>

                </div>

                {/* Item Finish */}
            </div>       
    {/*Accordian End*/}
    
</div>
</div>


</div>
</div>
</div>

<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>



</div></div></div>



      

        
        )
        }
        